<template>
  <div class="flex bg-white items-center px-2 rounded-lg text-xs mx-1 min-w-fit">
    {{ $t("reports.filters.date") }}
    <DatePicker
      format="yyyy-MM-dd"
      position="center"
      auto-apply
      :close-on-auto-apply="false"
      v-model="selectedDate"
      :rules="dateRule"
      placeholder="Select date"
      text-input
      required
      :clearable="false"
      @update:model-value="handleDateChange"
    />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'FilterSingleDayDateRange',
  props: {
    from: {
      type: String,
      default: () => moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
    },
    to: {
      type: String,
      default: () => moment().endOf("day").format("YYYY-MM-DD HH:mm:ss")
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:from', 'update:to', 'change', 'update:modelValue'],
  data() {
    return {
      selectedDate: moment(this.from).toDate(),
      dateRule: [
        (v) => !!v || this.$t("reports.filters.date_missing"),
      ]
    };
  },
  methods: {
    handleDateChange(value) {
      const date = moment(value);
      this.emitDateChange(date);
    },
    
    emitDateChange(date) {
      const from = date.startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const to = date.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      
      this.$emit('update:from', from);
      this.$emit('update:to', to);
      this.$emit('change', { from, to });
      
      // Emit preset key for parent to track
      if (date.isSame(moment(), 'day')) {
        this.$emit('update:modelValue', 'today');
      } else if (date.isSame(moment().subtract(1, 'day'), 'day')) {
        this.$emit('update:modelValue', 'yesterday');
      } else {
        this.$emit('update:modelValue', '');
      }
    },
    
    setDate(presetKey) {
      let date;
      if (presetKey === 'today') {
        date = moment();
      } else if (presetKey === 'yesterday') {
        date = moment().subtract(1, 'day');
      } else {
        return;
      }
      
      this.selectedDate = date.toDate();
      this.emitDateChange(date);
    }
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.setDate(newVal);
      }
    }
  }
};
</script>

